import { capitalize } from '@shared/utils/strings';

export const stringToSelectOption = s => ({ label: capitalize(s), value: s });
